import { render, staticRenderFns } from "./EstatisticasMensalidades.vue?vue&type=template&id=1ab4d4aa"
import script from "./EstatisticasMensalidades.vue?vue&type=script&lang=js"
export * from "./EstatisticasMensalidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports